/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseShipmentProvidersProvidersInner
 */
export interface GetConfig200ResponseShipmentProvidersProvidersInner {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseShipmentProvidersProvidersInner
     */
    name: string;
    /**
     * 
     * @type {any}
     * @memberof GetConfig200ResponseShipmentProvidersProvidersInner
     */
    config?: any | null;
}

/**
 * Check if a given object implements the GetConfig200ResponseShipmentProvidersProvidersInner interface.
 */
export function instanceOfGetConfig200ResponseShipmentProvidersProvidersInner(value: object): value is GetConfig200ResponseShipmentProvidersProvidersInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseShipmentProvidersProvidersInnerFromJSON(json: any): GetConfig200ResponseShipmentProvidersProvidersInner {
    return GetConfig200ResponseShipmentProvidersProvidersInnerFromJSONTyped(json, false);
}

export function GetConfig200ResponseShipmentProvidersProvidersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseShipmentProvidersProvidersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'config': json['config'] == null ? undefined : json['config'],
    };
}

export function GetConfig200ResponseShipmentProvidersProvidersInnerToJSON(json: any): GetConfig200ResponseShipmentProvidersProvidersInner {
    return GetConfig200ResponseShipmentProvidersProvidersInnerToJSONTyped(json, false);
}

export function GetConfig200ResponseShipmentProvidersProvidersInnerToJSONTyped(value?: GetConfig200ResponseShipmentProvidersProvidersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'config': value['config'],
    };
}

